<template>
    <b-modal id="model_delete" ref="model_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.model.data.attributes.name">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('model_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteModel">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../../components/Common/StateButton";
    export default {
        name: "ProductModelDeleteModal",

        components: {
            StateButton
        },

        props: [
            'model'
        ],

        methods: {
            hideModal(refname) {
                this.$refs[refname].hide();
            },

            deleteModel() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteModel', this.model)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-model');

                                this.$notify('error filled', 'Success!', 'Deleted the model!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('model_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
        }
    }
</script>

<style scoped>

</style>
